<template>
<div id="login">
    <div class="lgWrapper limiter container-login100" style="background-image: url('static/bg-01.jpg');">
        <div class="wrap-login100">
                <span class="login100-form-logo p-b-34">
                    <img src="/static/logo_login.png" width="386" height="234"/>
                </span>
                <span class="login100-form-title p-b-34">
                    Reset mật khẩu
                </span>
                    <span v-if="error_message != ''" class="message-error text-yellow">{{error_message}}</span>
                    <ul class="lgForm">
                        <li class="username">
                            <input type="text" name="email" v-model="model.email" class="form-control" required placeholder="Email đăng nhập" />
                        </li>
                        <li>
                            <button type="button" v-on:click="resetPassword()" class="btn btn-login">Reset mật khẩu</button>
                        </li>
                        <div class="row">
                            <div class="col-sm-6">
                                <router-link to="/dang-nhap" replace class="fgLink fr">Đăng nhập</router-link>
                            </div>
                            <div class="col-sm-6">
                                <router-link to="/dang-ky" replace class="fgLink fr align-right">Đăng ký</router-link>
                            </div>
                        </div>
                    </ul>
                </div>
            </div>
        <v-overlay :value="loading" z-index="999999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import {
    mapState
} from "vuex";

export default {
    computed: {
        ...mapState({
            token: state => state.authentication.token,
            resData: state => state.authentication.resData,
        }),
    },
    data: () => ({
        loading: false,
        model: {
            email: ''
        },
        error_message: ""
    }),
    watch: {
        resData() {
            if (this.resData && this.resData.status_code == 202) {
                this.error_message = 'Email không tồn tại.'
            } else {
                this.error_message = 'Reset mật khẩu thành công. Vui lòng kiểm tra email.';
            }
            this.loading = false;
        }
    },
    methods: {
        resetPassword() {
            this.loading = true;
            this.$store.dispatch('authentication/forgotPassword', this.model.email);
        }
    }

};
</script>

<style lang="css" scoped>
#login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
}
.align-right{
  float: right;
}
</style>
